<template>
  <RegisterLayout>
    <template #title>
      Заявка на обучение
    </template>
    <template #description>
      Выберите программу обучения
    </template>
    <el-form class="register__form">
      <el-row :gutter="16">
        <el-col>
          <el-form-item prop="first_name" :error="errors.course">
            <label>
              <span>Курс</span>
              <el-select v-model="formData.course" size="small">
                <el-option v-for="(course, id) in courses" :key="id" :value="id" :label="course" />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <template v-if="+formData.course === 1">
          <el-col :span="8">
            <el-form-item prop="day" :error="errors.day">
              <label>
                <span class="no-wrap">Желаемая дата начала обучения</span>
                <el-select v-model="formData.day" size="small" placeholder="Число">
                  <el-option :label="15" :value="15" />
                  <el-option :label="30" :value="30" />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="month" :error="errors.month">
              <label>
                <span>{{ '\u200B' }}</span>
                <el-select v-model="formData.month" size="small" placeholder="Месяц">
                  <el-option
                    v-for="(month, value) in months"
                    :key="month"
                    :label="month"
                    :value="value"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="your" :error="errors.your">
              <label>
                <span>{{ '\u200B' }}</span>
                <el-select v-model="formData.your" size="small" placeholder="Год">
                  <el-option v-for="your in yours" :key="your" :label="1901 + your" :value="your" />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="duration" :error="errors.duration">
              <label>
                <span>Длительность освоения</span>
                <el-select v-model="formData.duration" size="small">
                  <el-option
                    v-for="(duration, index) in durations"
                    :key="index"
                    :label="duration"
                    :value="index"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="direction" :error="errors.direction">
              <label>
                <span>Выберите направление подготовки</span>
                <el-select v-model="formData.direction" size="small">
                  <el-option
                    v-for="(direction, index) in directions"
                    :key="index"
                    :label="direction"
                    :value="index"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
        </template>
        <template v-else-if="+formData.course === 2">
          <el-col :span="8">
            <el-form-item prop="day" :error="errors.day">
              <label>
                <span class="no-wrap">Желаемая дата начала обучения</span>
                <el-select v-model="formData.day" size="small" placeholder="Число">
                  <el-option v-for="day in days" :key="day" :label="day" :value="day" />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="month" :error="errors.month">
              <label>
                <span>{{ '\u200B' }}</span>
                <el-select v-model="formData.month" size="small" placeholder="Месяц">
                  <el-option
                    v-for="(month, value) in months"
                    :key="month"
                    :label="month"
                    :value="value"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="your" :error="errors.your">
              <label>
                <span>{{ '\u200B' }}</span>
                <el-select v-model="formData.your" size="small" placeholder="Год">
                  <el-option v-for="your in yours" :key="your" :label="1901 + your" :value="your" />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="module" :error="errors.module">
              <label>
                <span>Выбрать модули (для выбора доступен только один модуль)</span>
                <el-select v-model="formData.module" size="small">
                  <el-option
                    v-for="(module, index) in modules"
                    :key="index"
                    :label="module"
                    :value="index"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="partner" :error="errors.partner">
              <label>
                <span>Организатор-Партнёр ЦПФ в Вашей стране</span>
                <el-select v-model="formData.partner" size="small">
                  <el-option
                    v-for="(partner, index) in partners"
                    :key="index"
                    :label="partner"
                    :value="index"
                  />
                </el-select>
              </label>
            </el-form-item>
          </el-col>
        </template>
        <template v-if="formData.course">
          <el-col>
            <el-form-item prop="agreement" :error="errors.agreement" class="register__agreement">
              <el-checkbox v-model="formData.agreement">
                Даю свое согласие на сбор, запись, систематизацию,накопление, хранение, уточнение
                (обновление, изменение), извлечение, использование предоставленных персональных
                данных.
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="contract" :error="errors.contract" class="register__agreement">
              <el-checkbox v-model="formData.contract">
                С <router-link to="/">Договором</router-link> публичной оферты от «….»________2020г.
                №_____ и <router-link to="/">приложениями</router-link> к нему ознакомился и
                согласен с условиями оплаты услуг, предоставляемых РУДН.
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col>
            <el-button
              type="success"
              class="register__button"
              @click="$router.push({ name: 'payment' })"
            >
              Оплатить сейчас 3 000 р
            </el-button>
            <Divider class="register__divider">
              Или
            </Divider>
            <el-button type="primary" class="register__button" @click="isVisibleSuccess = true">
              Отправить заявку и оплатить позже
            </el-button>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <RegisterStepTwoModal :visible.sync="isVisibleSuccess" />
  </RegisterLayout>
</template>

<script>
import DateSelect from '@/assets/mixins/date-select'
import RegisterLayout from '@/components/Auth/RegisterLayout'
import Divider from '@/components/Common/Divider'
import RegisterStepTwoModal from '@/components/Auth/RegisterStepTwoModal'

export default {
  name: 'StepTwo',
  components: { RegisterStepTwoModal, Divider, RegisterLayout },
  mixins: [DateSelect],
  data: () => ({
    isVisibleSuccess: false,

    formData: {
      course: '',
      duration: '',
      disciplines: [],
      agreement: false,
      contract: false,
      direction: '',
      module: '',
      partner: ''
    },

    durations: [
      'Интенсивное прохождение (6 мес.)',
      'Стандартное прохождение (9 мес.)',
      'Долгосрочное прохождение (до 2 лет)'
    ],

    errors: {
      course: '',
      duration: '',
      education: '',
      direction: '',
      module: '',
      partner: ''
    },

    partners: ['Партнёр 1', 'Партнёр 2', 'Нет партнера'],

    courses: {
      1: 'Базовый',
      2: 'Отдельные модули'
    },

    directions: [
      'Естественно-научный',
      'Гуманитарный',
      'Медико-биологический',
      'Экономический',
      'Инженерно-технический'
    ],

    modules: [
      'Вводно-фонетический курс',
      'Русский язык. А1, элементарный уровень',
      'Русский язык. А2, базовый уровень',
      'Русский язык. В1, первый сертификационный уровень',
      'Математика',
      'Химия',
      'Физика',
      'История',
      'Обществознание',
      'Литература',
      'Информатика',
      'Биология',
      'Научный стиль речи: Естественно-научный профиль',
      'Научный стиль речи: Гуманитарный профиль',
      'Научный стиль речи: Медико-биологический профиль',
      'Научный стиль речи: Экономический профиль',
      'Научный стиль речи: Инженерно-технический профиль'
    ]
  })
}
</script>

<style scoped lang="scss">
.register {
  &__form {
    width: 390px;

    @include sm-and-down {
      width: 100%;
    }
  }

  &__agreement {
    &::v-deep .el-form-item__content .el-checkbox {
      align-items: flex-start;
      flex-direction: row;

      &__label {
        white-space: normal;
        display: block;
        font-size: 12px;
        line-height: 14px;
        color: $deepdark;
        font-weight: normal;
        padding: 0;
        margin-left: 8px;

        a {
          color: $luchmara;
          text-decoration: underline;
        }
      }
    }
  }

  &__button {
    width: 100%;
  }

  &__divider {
    margin: 8px 0;
  }
}
</style>
